var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8917 10.9417C15.0334 11.7167 15.8334 12.7667 15.8334 14.1667V16.6667H18.3334C18.7917 16.6667 19.1667 16.2917 19.1667 15.8333V14.1667C19.1667 12.35 16.1917 11.275 13.8917 10.9417Z",
    fill: "#313947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 10C9.34103 10 10.8334 8.50763 10.8334 6.66668C10.8334 4.82573 9.34103 3.33334 7.50008 3.33334C5.65913 3.33334 4.16675 4.82573 4.16675 6.66668C4.16675 8.50763 5.65913 10 7.50008 10Z",
    fill: "#313947"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 10C14.3417 10 15.8334 8.50834 15.8334 6.66668C15.8334 4.82501 14.3417 3.33334 12.5001 3.33334C12.1084 3.33334 11.7417 3.41668 11.3917 3.53334C12.0834 4.39168 12.5001 5.48334 12.5001 6.66668C12.5001 7.85001 12.0834 8.94168 11.3917 9.80001C11.7417 9.91668 12.1084 10 12.5001 10Z",
    fill: "#313947"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50004 10.8333C5.27504 10.8333 0.833374 11.95 0.833374 14.1667V15.8333C0.833374 16.2917 1.20837 16.6667 1.66671 16.6667H13.3334C13.7917 16.6667 14.1667 16.2917 14.1667 15.8333V14.1667C14.1667 11.95 9.72504 10.8333 7.50004 10.8333Z",
    fill: "#313947"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.33477634b559dbe7e71f4086508b2378.svg";
export { ForwardRef as ReactComponent };